import { FC, InputHTMLAttributes } from "react"
import clsx from "clsx"

export interface TextInputProps extends InputHTMLAttributes<any> {
  errorText?: string
  inputClassName?: string
}

export const TextInput: FC<TextInputProps> = ({
  errorText,
  className,
  inputClassName,
  ...props
}) => {
  return (
    <div className={clsx("relative", className)}>
      <input
        {...props}
        className={clsx(
          inputClassName,
          "py-2.5 px-3 rounded-xl w-full",
          "focus:outline-none focus:shadow-outline",
          errorText && "border-red border"
        )}
      />
      <small className="text-red">{errorText}</small>
    </div>
  )
}
